
import { createClient } from '@supabase/supabase-js';
import { CONFIG } from './config';

const supabaseUrl = CONFIG.SUPABASE_URL || 'https://placeholder-project.supabase.co';
const supabaseKey = CONFIG.SUPABASE_ANON_KEY || 'placeholder-key';

// Only warn, don't throw, allowing the app to fall back to local storage
if (!CONFIG.IS_SUPABASE_CONFIGURED) {
  console.warn("WonderVerse: Running in Local-Only mode. Supabase configuration missing.");
}

export const supabase = createClient(supabaseUrl, supabaseKey);
